import { FontTShirtSize, TextAlignment } from '@modules/common/models'
import styled from 'styled-components'

interface RowProps {
  height?: number
  width?: number
  rowInactive?: boolean
  rowBottomBorderWidth?: number
  rowTopBorderWidth?: number
  borderColor?: string
}

export const StandardTableRow = styled.div<RowProps>((props: any) => {
  const borderColor = props.borderColor ? props.borderColor : 'var(--Whitesmoke)'
  return {
    //If there is only one column in table, it should take full width
    width: props.width ? props.width + 'px !important' : '100%',
    height: props.height,
    background: 'var(--background-white)',
    whiteSpace: 'nowrap',
    borderBottom:
      props.rowBottomBorderWidth &&
      `solid ${props.rowBottomBorderWidth}px ${borderColor}`,
    borderTop:
      props.rowTopBorderWidth && `solid ${props.rowTopBorderWidth}px ${borderColor}`,
    opacity: props.rowInactive && 0.6
  }
})

interface CellProps {
  fontSize?: FontTShirtSize
  cellWidth: number
  cellHeight?: number
  cellPad?: string
  alignment?: any
  cellZIndex?: number
  cellTextWrap?: boolean
  isDisabled?: boolean
  showLeftBorder?: boolean
  stickyLeft?: number
  isCellShadow?: boolean
  isUpperCase?: boolean
  totalBorderHeight?: number
  totalPaddingHeight?: number
}

export const StandardTableCell = styled.div<CellProps>((props: any) => {
  const {
    fontSize,
    cellPad,
    alignment,
    cellZIndex,
    cellHeight,
    isDisabled,
    showLeftBorder,
    stickyLeft,
    isCellShadow,
    isUpperCase,
    totalBorderHeight,
    totalPaddingHeight
  } = props

  const isSticky = stickyLeft || stickyLeft === 0
  const borderHeight = totalBorderHeight ? totalBorderHeight : 0
  const paddingHeight = totalPaddingHeight ? totalPaddingHeight : 0
  return {
    '&&': {
      whiteSpace: 'pre-wrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      backgroundColor: 'var(--background-white)',
      display: 'inline-block',
      font: fontSize ? fontSize : 'var(--typography-body2)',
      letterSpacing: 'var(--label-typography-letter-spacing)',
      color: 'var(--black)',
      textTransform: isUpperCase ? 'uppercase' : 'none',
      width: props.cellWidth,
      height: cellHeight
        ? `${cellHeight}px`
        : `calc(100% - ${borderHeight + paddingHeight}px)`,
      position: isSticky ? 'sticky' : undefined,
      left: isSticky ? `${stickyLeft}px` : 0,
      zIndex: isSticky ? (cellZIndex ? cellZIndex : 2) : undefined,
      padding: cellPad,
      borderLeft: showLeftBorder && 'var(--cell-border-bottom)',
      textAlign: alignment ? alignment : TextAlignment.left,
      boxShadow: isCellShadow ? '8px 0 5px -3px rgba(133, 146, 166, 0.2)' : undefined,
      opacity: isDisabled ? 0.3 : undefined
    }
  }
})
